// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_LinkExpensesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/link_expenses/{period_id}
 *
 * Validates input for linking expenses to a payroll period.
 */
import { registerContract } from './validate'

export interface Payroll_LinkExpensesInput {
franchise_id: number
expense_ids: number[]
}

registerContract('Payroll_LinkExpensesInput', {
  franchise_id: { type: 'number',  required: true },
  expense_ids:  { type: 'array',   required: true },
})
